import { render, staticRenderFns } from "./ComponentTest.vue?vue&type=template&id=31f0f184&scoped=true"
import script from "./ComponentTest.vue?vue&type=script&lang=js"
export * from "./ComponentTest.vue?vue&type=script&lang=js"
import style0 from "./ComponentTest.vue?vue&type=style&index=0&id=31f0f184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0f184",
  null
  
)

export default component.exports